module.exports = __webpack_public_path__ + "static/media/24UHCHR1.1eb8465a.jpg";